<template>
<m-pageframe
    :title="title"
    :color="pageframe_color"
>
<v-container
    v-if="open_contact_requests != null"
>
    <lightbox-awareness />

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        
    </v-text-field>

    
    <div
        style="text-align: center; font-size: 20px; margin-top: 100px; margin-bottom: 100px; color: rgba(0,0,0,0.5);"
        v-if="open_contact_requests.length == 0"
    >
        <span v-if="full_text == null || full_text.trim() == ''">
            You have no open contact requests.
        </span>
        <span v-else>
            You have no open contact requests that match your search.
        </span>
    </div>

   <m-contact-request-card
        v-for="(contact_request, index) in open_contact_requests"
        :key="index"
        :contact_request="contact_request"
        :organization_id="organization_id"
        v-on:search="doUpdate();"
    />

    <v-pagination
      v-model="page"
      :length="page_count"
      :total-visible="7"
      v-if="page_count > 1"
    ></v-pagination>

    <m-icon-bar
        v-on:add="onCreateContactRequest"
    />

  
</v-container>

<m-create-contact-request-dialog
    ref="create-contact-request-dialog"
    v-on:ok="onCreateNewContactRequest($event)"
/>

</m-pageframe>
</template>

<script>


const { v4: uuidv4 } = require('uuid');
const _ = require('lodash');
import LightboxAwareness from '@/components/lightbox/lightbox-awareness.vue';

export default {
    components: {
        LightboxAwareness,
    },

    data() {
        return {
            page: 1,
            full_text: null,
            organization_id: null,
            employee_id: null,
            all_open_contact_requests: [],
        }
    },

    mounted () {
        this.doUpdate();
    },

    created () {
        this.$event_bus.$on('upsert-contact-request', this.onContactRequestNotice);
        
    },

    beforeDestroy () {
        this.$event_bus.$off('upsert-contact-request',this.onContactRequestNotice);
    },

    methods: {

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.showSpinner();
            this.$rc.rest(
                'LIST: /api/v1/contact-requests/open',
            
                {
                    'employee_id' : this.$route.params.employee_id,
                    'full_text' : this.full_text,
                },
            
                (response_data) => {
                    this.$rc.hideSpinner();

                    this.organization_id = response_data.organization_id;
                    this.employee_id = response_data.employee_id;

                    this.all_open_contact_requests = response_data.open_contact_requests;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Search error', 'Unable to search open contact requests');
                },
            );
        },
        

        onCreateContactRequest()
        {
            this.$refs['create-contact-request-dialog'].showDialog(this.organization_id);
        },

        onCreateNewContactRequest(info)
        {
            let contact_request = {
                'organization_id' : this.organization_id,
                'contact_request_id' : uuidv4(),
                'assign_to_employee_ids' : info.assign_to_employee_ids,
                'created_by_employee_id' : this.employee_id,
                'customer_name' : info.customer_name,
                'customer_endpoint' : info.customer_endpoint,
                'message' : info.message,
                'blob_ids' : info.blob_ids
            };

            this.show_spinner = true;

            this.$rc.createEmployeeContactRequest(
                contact_request,

                () => {
                    this.doUpdate();
                    this.$rc.snackbar('New contact request created',3500);
                },

                () => {
                    this.$rc.alert('Error', 'Unable to create contact request');
                }
            )
        },

        onContactRequestNotice(notice)
        {
            this.doUpdate();
        },
    },

    computed: {
        title() {
            if ( this.employee_profile == null ) return "Search Open Contact Requests";

            return 'Search Open Contact Requests: '+this.employee_profile.employee_account.username;
        },

        pageframe_color() {
            if ( this.employee_id != null && this.employee_id != this.$rc.$state.employee_id ) 
                return '#5D647C';

            // primary
            return '#F24653';
        },

        open_contact_requests() {
            let ret = [];

            let page_start = (this.page-1) * 10;
            let page_stop = (this.page)*10;

            for ( let i = 0; i < this.all_open_contact_requests.length; i++ )
            {
                if ( i < page_start ) continue;
                if ( i > page_stop ) continue;

                ret.push(this.all_open_contact_requests[i]);
            }

            return ret;
        },

        page_count()
        {
            if ( this.all_open_contact_requests == null ) return 1;
            if ( this.all_open_contact_requests.length < 10 ) return 1;
            return Math.ceil(this.all_open_contact_requests.length / 10);
        },
    },
}
</script>

<style lang="scss" scoped>
.heading {
    font-weight: bold;
}
</style>